import SafegraphLapsedUserThumb from 'assets/icons/ReportThumbs/safegraph_lapsed_user.png';
import SafegraphVisitorShare from 'assets/icons/ReportThumbs/safegraph_visitor_share.png';

export default [
  {
    key: 'safegraphLapsedUser',
    text: 'Safegraph Lapsed User',
    image: SafegraphLapsedUserThumb,
    meta: { thirdPartyReport: true, showForOnline: true, type: 'Third Party' },
  },
  {
    key: 'safegraphVisitorShare',
    text: 'Safegraph Visitor Share',
    image: SafegraphVisitorShare,
    meta: { thirdPartyReport: true, showForOnline: true, type: 'Third Party' },
  },
];
